/*
 * Copyright (c) 2025.  Chad and contributors.
 * All rights reserved.
 */


export const isOnline = () => typeof navigator !== 'undefined' && navigator.onLine;
